import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { AppRoutingModule } from './app-routing.module';
import { MaterialModule } from './material.module';
import { AppComponent } from './app.component';
import { HttpClientModule } from '@angular/common/http';
import { CurrencyPipe} from '@angular/common';
import { JwtHelperService, JWT_OPTIONS } from '@auth0/angular-jwt';
import { NavService } from 'src/app/Services/NavService';
import { LoginComponent } from './Componentes/Autenticacion/login/login.component';
import { RecuperarComponent } from './Componentes/Autenticacion/recuperarcontrasena/recuperar.component';
import { CambioComponent } from './Componentes/Autenticacion/cambiocontrasena/cambio.component';
import { HomeComponent } from './Componentes/Inicio/Home/home.component';
import { ReactiveFormsModule } from '@angular/forms';
import { OpenModal } from './OpenModal';
import { MyModalComponent } from './shared/my-modal.component';
import { RecaptchaFormsModule, RecaptchaModule, RECAPTCHA_LANGUAGE } from 'ng-recaptcha';
import { Globales } from './Global';
import { CurrencyMaskModule } from 'ng2-currency-mask';
import { CURRENCY_MASK_CONFIG } from 'ng2-currency-mask/src/currency-mask.config';
import { CustomCurrencyMaskConfig } from './CustomCurrencyMaskConfig';
import {
  MatToolbarModule, MatIconModule, MatSidenavModule, MatListModule, MAT_DATE_LOCALE, MatButtonModule, MatMenuModule,
  MatCardModule, MatExpansionModule, MatTabsModule, MatPaginatorIntl
} from '@angular/material';
import { NavigationLeftComponent } from './Componentes/Menu/navigation-left/navigation-left.component';
import { SidenavService } from './Componentes/Menu/services/sidenav.service';
import { MenuLinkComponent } from './Componentes/Menu/menu-link/menu-link.component';
import { MatPaginatorIntlCro } from './Table';
import { NgxChartsModule } from '@swimlane/ngx-charts';
import { LogoComponent } from './Componentes/Inicio/logo/logo.component';
import { ReceptorDirective } from './Directives/receptor.directive';
import { MantenedorSucursalListComponent } from './Componentes/mantenedores/mantenedor-sucursal/mantenedor-sucursal-list/mantenedor-sucursal-list.component';
import { MantenedorSucursalEditComponent } from './Componentes/mantenedores/mantenedor-sucursal/mantenedor-sucursal-edit/mantenedor-sucursal-edit.component';
import { MantenedorSucursalAddComponent } from './Componentes/mantenedores/mantenedor-sucursal/mantenedor-sucursal-add/mantenedor-sucursal-add.component';
import { MantenedorUsuarioListComponent } from './Componentes/mantenedores/mantenedor-usuario/mantenedor-usuario-list/mantenedor-usuario-list.component';
import { MantenedorUsuarioAddComponent } from './Componentes/mantenedores/mantenedor-usuario/mantenedor-usuario-add/mantenedor-usuario-add.component';
import { MantenedorUsuarioEditComponent } from './Componentes/mantenedores/mantenedor-usuario/mantenedor-usuario-edit/mantenedor-usuario-edit.component';
import { RepoteVentasComponentComponent } from './Componentes/Reportes/repote-ventas-component/repote-ventas-component.component';
import { RepoteComisionesComponentComponent } from './Componentes/Reportes/repote-comisiones-component/repote-comisiones-component.component';
import { VentasListComponent } from './Componentes/ventas/ventas-list/ventas-list.component';
import { VentasAddComponent } from './Componentes/ventas/ventas-add/ventas-add.component';
import { VentasAddConductorComponent } from './Componentes/ventas/ventas-add-conductor/ventas-add-conductor.component';
import { CambiarPermisosComponent } from './Componentes/mantenedores/mantenedor-usuario/cambiar-permisos/cambiar-permisos.component';
import { ReporteVentasVendedorComponent } from './Componentes/Reportes/reporte-ventas-vendedor/reporte-ventas-vendedor.component';

@NgModule({
  declarations: [
    AppComponent,
    LoginComponent,
    RecuperarComponent,
    CambioComponent,
    HomeComponent,
    MyModalComponent,
    NavigationLeftComponent,
    MenuLinkComponent,
    LogoComponent, ReceptorDirective, MantenedorSucursalListComponent, MantenedorSucursalEditComponent, MantenedorSucursalAddComponent, MantenedorUsuarioListComponent, MantenedorUsuarioAddComponent, MantenedorUsuarioEditComponent, VentasListComponent, VentasAddComponent, VentasAddConductorComponent,RepoteVentasComponentComponent, RepoteComisionesComponentComponent, CambiarPermisosComponent, ReporteVentasVendedorComponent
  ],
  entryComponents: [
    MyModalComponent,
    HomeComponent,
    MantenedorSucursalEditComponent,
    MantenedorSucursalAddComponent,
    MantenedorUsuarioAddComponent,
    MantenedorUsuarioEditComponent,
    VentasAddComponent,
    VentasAddConductorComponent,
    CambiarPermisosComponent
  ],
  imports: [
    // AppComponent,
    CurrencyMaskModule,
    BrowserModule,
    AppRoutingModule,
    FormsModule,
    BrowserAnimationsModule,
    MaterialModule,
    HttpClientModule,
    ReactiveFormsModule,
    RecaptchaModule,
    RecaptchaFormsModule,
    MatToolbarModule,
    MatSidenavModule,
    MatListModule,
    MatButtonModule,
    MatIconModule,
    MatCardModule,
    MatMenuModule,
    MatExpansionModule,
    MatTabsModule,
    NgxChartsModule
  ],
  exports: [CambioComponent],
  providers: [CurrencyPipe,OpenModal, SidenavService, HomeComponent, Globales,
    {
      provide: JWT_OPTIONS,
      useValue: JWT_OPTIONS
    },
    JwtHelperService,
    {
      provide: RECAPTCHA_LANGUAGE,
      useValue: 'es',
    },
    { provide: MAT_DATE_LOCALE, useValue: 'es-CL' },
    [{ provide: MatPaginatorIntl, useClass: MatPaginatorIntlCro }],
    { provide: CURRENCY_MASK_CONFIG, useValue: CustomCurrencyMaskConfig }
  ],
  bootstrap: [AppComponent]


})
export class AppModule { }
